import { isAlcoholNull } from 'utils/validators'
import { useTranslation } from 'react-i18next'
import { Wrapper, Parameter, Value, Label } from './_styles'

const ChemicalAnalisys = ({ product }) => {
  const { t } = useTranslation()

  const chemicalAnalysis = product?.wine?.chemicalAnalysis

  const alcoholVolume = chemicalAnalysis?.alcoholVolume ?? ''
  const rs = chemicalAnalysis?.residualSugar ?? ''
  const ta = chemicalAnalysis?.acidityTotal?.value
  const taUnit = chemicalAnalysis?.acidityTotal?.unit?.masterName ?? ''
  const ph = chemicalAnalysis?.pH ?? ''

  if (isAlcoholNull(alcoholVolume) && !rs && !ta && !ph) return null

  return (
    <Wrapper>
      {!isAlcoholNull(alcoholVolume) && alcoholVolume >= 0 && (
        <Parameter>
          <Label>{t('wine.techlist.abv')}: </Label>
          <Value>{alcoholVolume}%</Value>
        </Parameter>
      )}

      {Boolean(rs) && (
        <Parameter>
          <Label>{t('wine.techlist.rs')}: </Label>
          <Value>{rs} g/l</Value>
        </Parameter>
      )}

      {Boolean(ta) && (
        <Parameter>
          <Label>{t('wine.techlist.ta')}: </Label>
          <Value>
            {ta} {taUnit || 'g/l'}
          </Value>
        </Parameter>
      )}

      {Boolean(ph) && (
        <Parameter>
          <Label>{t('wine.techlist.ph')}: </Label>
          <Value>{ph}</Value>
        </Parameter>
      )}
    </Wrapper>
  )
}

export default ChemicalAnalisys
